import {
  Add,
  ArrowBack,
  Beenhere,
  CheckCircle,
  DeleteOutlineOutlined,
  ShoppingBagOutlined,
  ShoppingCart,
} from "@mui/icons-material";
import {
  Badge,
  Box,
  Button,
  CircularProgress,
  Divider,
  Drawer,
  FormControl,
  FormControlLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Rating,
  Select,
  Step,
  StepLabel,
  Stepper,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { myAddressList } from "../../Services/Address/AddressList";
import { useMutation, useQuery, useQueryClient } from "react-query";
import classNames from "classnames";
import { codCheckoutFn } from "../../Services/Checkout/CashOnDelivery";
import { useNavigate } from "react-router-dom";
import Cart from "./Cart";
import { myCartList } from "../../Services/Cart/CartList";
import { useFormik } from "formik";
import { countryListFn } from "../../Services/Address/Country";
import { stateListFn } from "../../Services/Address/State";
import { cityListFn } from "../../Services/Address/City";
import { addAddressFn } from "../../Services/Address/AddAddress";
import { addAddressSchema } from "../../Schemas";
import { checkOutFn } from "../../Services/Checkout/Online";
import { paymentReceiptFn } from "../../Services/Checkout/PaymentReceipt";
import { useDispatch, useSelector } from "react-redux";
import { setSnackbar } from "../../Redux/Actions/SnackBar";
import { increaseCartFn } from "../../Services/Cart/IncreaseCartItem";
import { decreaseCartFn } from "../../Services/Cart/DecreaseCartItem";
import { removeCartFn } from "../../Services/Cart/RemoveCartItem";
import { addToWishListFn } from "../../Services/Products/AddToWishlist";
import { setCart } from "../../Redux/Actions/Cart";

const Checkout = () => {
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(0);
  const [addressId, setAddressId] = useState();
  const [method, setMethod] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [receipt, setReceipt] = useState(null);
  const [response, setResponse] = useState(false);
  const [cartList, setCartList] = useState([]);

  const navigate = useNavigate();
  const client = useQueryClient();
  const cart = useSelector((state) => state.cart);
  const labels = [
    "Order Summary",
    "Choose Address",
    "Payment Method",
    "Order Placed",
  ];
  const { data: addressList } = useQuery(
    ["myAddressList", step],
    () => step === 1 && myAddressList(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  const { mutate: codCheckout, isLoading } = useMutation(codCheckoutFn, {
    onSuccess: () => {
      setStep(3);
      client.refetchQueries("cartList");
      client.refetchQueries("myOrderList");
    },
  });
  const { data: cartListData, isLoading: isLoadingCart } = useQuery(
    ["cartList", response],
    () => localStorage.getItem("bhaarattoken") && myCartList(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
  useEffect(
    () => {
      localStorage.getItem("bhaarattoken")
        ? setCartList(cartListData)
        : setCartList(cart);
    },
    // eslint-disable-next-line
    [cart, response, cartListData]
  );

  const increaseCartWithoutLogin = (variant, quantity) => {
    const index = cart?.findIndex(
      (cart) => cart.item.variant_id === variant.variant_id
    );
    cart[index].quantity = quantity !== 10 ? quantity + 1 : quantity;
    dispatch(setCart(cart));
    setCartList(cart);
    setResponse(!response);
  };
  const decreaseCartWithoutLogin = (variant, quantity) => {
    const index = cart?.findIndex(
      (cart) => cart.item.variant_id === variant.variant_id
    );
    cart[index].quantity = quantity !== 1 ? quantity - 1 : quantity;
    dispatch(setCart(cart));
    setCartList(cart);
    setResponse(!response);
  };
  const removeCartWithoutLogin = (variant) => {
    dispatch(setCart(cart?.filter((cart) => cart.item.variant_id !== variant)));
  };

  useEffect(() => {
    cart?.length !== 0 && localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart, cartList, response]);

  const { mutate: addAddress } = useMutation(addAddressFn, {
    onSuccess: (res) => {
      console.log(res.data);
      client.refetchQueries("myAddressList");
      setIsOpen(false);
    },
  });
  const { mutate: increaseCart } = useMutation(increaseCartFn, {
    onSuccess: (res) => {
      client.refetchQueries("cartList");
    },
  });
  const { mutate: decreaseCart } = useMutation(decreaseCartFn, {
    onSuccess: (res) => {
      client.refetchQueries("cartList");
    },
  });
  const { mutate: removeCart } = useMutation(removeCartFn, {
    onSuccess: (res) => {
      res.data.status === "Product deleted Successfully !!!" &&
        client.refetchQueries("cartList");
    },
  });
  const { mutate: addToWishlist } = useMutation(addToWishListFn, {
    onSuccess: (response) => {
      dispatch(
        setSnackbar({
          open: true,
          message: response?.data?.status,
          variant: "success",
        })
      );
      response.data.status === "Product added to wishlist" &&
        client.refetchQueries("myWishList");
    },
  });
  const handleMoveToCart = (variant_id, cart_id) => {
    addToWishlist({
      add_quantity: 1,
      product_id: Number(variant_id),
    });
    removeCart({ cart_id: cart_id });
  };

  const initialValues = {
    address_type: "",
    area: "",
    street_address: "",
    city_id: "",
    state_id: "",
    country_id: "",
    pincode: "",
    email: "",
    mobile_number: "",
    address: "",
  };
  const { handleBlur, handleChange, handleSubmit, values, touched, errors } =
    useFormik({
      initialValues: initialValues,
      validationSchema: addAddressSchema,
      onSubmit: () => {
        const reqBody = {
          address_type: values.address_type,
          address: values.address,
          area: values.area,
          street_address: values.street_address,
          city_id: values.city_id,
          state_id: values.state_id,
          country_id: values.country_id,
          pincode: values.pincode,
          email: values.email,
          mobile_number: values.mobile_number,
        };
        addAddress(reqBody);
      },
    });
  const { data: country } = useQuery(
    ["country"],
    () => isOpen && countryListFn(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
  const { data: state } = useQuery(
    ["state", values.country_id],
    () => values.country_id && stateListFn({ country_id: values.country_id }),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
  const { data: city } = useQuery(
    ["city", values.state_id],
    () => values.state_id && cityListFn({ state_id: values.state_id }),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
  const { mutate: paymentReceipt, isLoading: isLoadingOrder } = useMutation(
    paymentReceiptFn,
    {
      onSuccess: (response) => {
        setReceipt(response.data.data.payment_receipt[0]);
      },
    }
  );
  const dispatch = useDispatch();
  const RazorPay = () => {
    const options = {
      // key: "rzp_live_WjOufVCBRpvN9u",
      key: "rzp_test_vDJzs5kXvURgrY",
      currency: "INR",
      amount: cartList?.data?.data?.[0]?.cart_total_amount,
      name: "Bhaarat Store",
      order_id: receipt?.razorpay_order_id,
      handler: () => {
        const reqbody = new FormData();
        reqbody.append("address_id", addressId);
        reqbody.append("coupon_id", "None");
        reqbody.append("payment_receipt_id", receipt?.payment_receipt_id);
        checkOut(reqbody);
        client.refetchQueries("myOrderList");
      },
      theme: {
        color: "#800120",
      },
    };
    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };

  useEffect(
    () => {
      receipt && method === "Online" && RazorPay();
    },
    // eslint-disable-next-line
    [receipt]
  );

  const { mutate: checkOut, isLoading: isLoadingOnline } = useMutation(
    checkOutFn,
    {
      onSuccess: (response) => {
        dispatch(
          setSnackbar({
            open: true,
            message: response.data.status,
            variant: "success",
          })
        );
        response.data.status ===
          "Your Order has been created Successfully !!!" && setStep(3);
        response.data.status ===
          "Your Order has been created Successfully !!!" &&
          client.refetchQueries("cartList");
        response.data.status ===
          "Your Order has been created Successfully !!!" &&
          client.refetchQueries("myOrderList");
      },
    }
  );
  const cart_total_price = cart
    ?.map((i) => parseFloat(i.item.variant_price * i.quantity))
    .reduce((a, b) => a + b, 0);
  const cart_total_amount = cart
    ?.map((i) => parseFloat(i.item.actual_price * i.quantity))
    .reduce((a, b) => a + b, 0);
  return (
    <>
      <Badge
        badgeContent={cartList?.data?.data?.length || cartList?.length}
        color="primary"
      >
        <ShoppingBagOutlined onClick={() => setOpen(true)} />
      </Badge>
      <Drawer anchor="right" open={open} PaperProps={{ className: "!w-full" }}>
        <div className="fixed h-16 z-50 flex items-center gap-5 bg-white dark:bg-zinc-900  px-2 shadow w-full">
          <ArrowBack onClick={() => setOpen(false)} />
          <p className="font-semibold text-lg">My Cart</p>
        </div>
        <div className="flex flex-col  pt-16 h-full">
          {step !== 0 && (
            <div className="pt-5">
              <Stepper activeStep={step} alternativeLabel>
                {labels.map((label) => (
                  <Step key={label}>
                    <StepLabel className="!text-xs">{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </div>
          )}
          {/* Cart Items  */}
          {step === 0 && (
            <>
              {(cartList?.data?.data?.length || cartList?.length) !== 0 ? (
                <>
                  <div className="flex flex-col bg-zinc-200 dark:bg-zinc-700 p-2 h-full overflow-y-auto hide-scroll">
                    {localStorage.getItem("bhaarattoken") ? (
                      <div className="pb-20">
                        {cartList?.data?.data?.map((cart) => {
                          return (
                            <>
                              <div className="flex justify-between items-start bg-white dark:bg-zinc-900 rounded-lg p-3">
                                <div className="flex-col flex gap-2">
                                  <p className="font-semibold">{cart.title}</p>
                                  {cart.color_variant_values ? (
                                    <p className="text-xs">
                                      {cart.color_variant_values},
                                      {cart.other_variant_values},
                                      {cart.storage_variant_values}
                                    </p>
                                  ) : (
                                    <p className="text-xs">
                                      {cart.storage_variant_values}
                                    </p>
                                  )}
                                  <Rating
                                    size="small"
                                    readOnly
                                    value={5}
                                    className="!text-green-600 !item-left !border-black "
                                  />

                                  <span className="flex text-xs items-center gap-1">
                                    <p
                                      className={classNames(
                                        "line-through",
                                        cart.discount_percent === "0.0"
                                          ? "hidden"
                                          : ""
                                      )}
                                    >
                                      {cart.price}
                                    </p>
                                    <p className="font-semibold">
                                      {" "}
                                      ₹{cart.actual_price}
                                    </p>
                                    <span
                                      className={classNames(
                                        "text-green-700",
                                        cart.discount_percent === "0.0"
                                          ? "hidden"
                                          : ""
                                      )}
                                    >
                                      {cart.discount_percent}% off
                                    </span>
                                  </span>
                                  <p className="text-sm">
                                    Delivery Charge :{" "}
                                    {cart.cart_delivery_charges}
                                  </p>
                                </div>
                                <span className="w-1/4 flex flex-col items-center gap-2">
                                  <img
                                    src={cart.variant_image}
                                    alt=""
                                    className="h-16 rounded"
                                  />
                                  <span className="flex text-xl items-center border-2 border-zinc-200 dark:border-zinc-700 rounded px-3 gap-2">
                                    <span
                                      className="px-px"
                                      onClick={() =>
                                        decreaseCart({
                                          cart_id: cart.cart_product_id,
                                        })
                                      }
                                    >
                                      -
                                    </span>
                                    <span className="border-x border-zinc-200 dark:border-zinc-700 px-2">
                                      {cart.cart_product_quantity}
                                    </span>
                                    <span
                                      onClick={() =>
                                        increaseCart({
                                          cart_id: cart.cart_product_id,
                                        })
                                      }
                                    >
                                      +
                                    </span>
                                  </span>
                                </span>
                              </div>
                              <Divider className="!mx-2" />
                              <div className="flex bg-white dark:bg-zinc-900 rounded-lg">
                                <Button
                                  startIcon={<Beenhere />}
                                  variant="text"
                                  className="!capitalize !rounded-l-lg !rounded-r-none !text-black dark:!text-white w-1/2"
                                  onClick={() =>
                                    handleMoveToCart(
                                      cart.variant_id,
                                      cart.cart_product_id
                                    )
                                  }
                                >
                                  Save for Later
                                </Button>
                                <div className="border"></div>
                                <Button
                                  startIcon={<DeleteOutlineOutlined />}
                                  onClick={() =>
                                    removeCart({
                                      cart_id: cart.cart_product_id,
                                    })
                                  }
                                  variant="text"
                                  className="!capitalize !rounded-r-lg !rounded-l-none !text-black dark:!text-white w-1/2"
                                >
                                  Remove
                                </Button>
                              </div>
                              <Divider className="!mx-2" />
                            </>
                          );
                        })}

                        <div className="py-2 px-3 bg-white dark:bg-zinc-900 rounded-lg">
                          Price details
                        </div>
                        <Divider className="!mx-2" />
                        <div className="text-right flex bg-white dark:bg-zinc-900 rounded-lg flex-col p-2 gap-2">
                          <p>
                            Total Amount:
                            <span className="font-semibold mx-2">
                              ₹{cartList?.data?.data?.[0]?.cart_total_price}
                            </span>
                          </p>
                          <p>
                            Discount:
                            <span className="font-semibold mx-2">
                              ₹{cartList?.data?.data?.[0]?.cart_total_discount}
                            </span>
                          </p>
                          <p>
                            Tax:
                            <span className="font-semibold mx-2">
                              ₹{cartList?.data?.data?.[0]?.cart_tax}
                            </span>
                          </p>
                          <p>
                            Delivery Charge:
                            <span className="font-semibold mx-2">
                              {cartList?.data?.data?.[0]
                                ?.cart_delivery_charges !== "Free" ? (
                                <>
                                  ₹
                                  {
                                    cartList?.data?.data?.[0]
                                      ?.cart_delivery_charges
                                  }
                                </>
                              ) : (
                                cartList?.data?.data?.[0]?.cart_delivery_charges
                              )}
                            </span>
                          </p>
                          <Divider />
                          <p className="pb-2">
                            Total Cart Amount:
                            <span className="font-semibold mx-2">
                              ₹{cartList?.data?.data?.[0]?.cart_total_amount}
                            </span>
                          </p>
                        </div>
                      </div>
                    ) : (
                      <div className="pb-20">
                        {cartList?.map((cart) => {
                          return (
                            <>
                              <div className="flex justify-between items-start bg-white dark:bg-zinc-900 rounded-lg p-3">
                                <div className="flex-col flex gap-2">
                                  <p className="font-semibold">
                                    {cart?.item?.variant_name}
                                  </p>
                                  {cart?.item?.color_variant_values ? (
                                    <p className="text-xs">
                                      {cart?.item?.color_variant_values},
                                      {cart?.item?.other_variant_values},
                                      {cart?.item?.storage_variant_values}
                                    </p>
                                  ) : (
                                    <p className="text-xs">
                                      {cart?.item?.storage_variant_values}
                                    </p>
                                  )}
                                  <Rating
                                    size="small"
                                    readOnly
                                    value={5}
                                    className="!text-green-600 !item-left !border-black "
                                  />

                                  <span className="flex text-xs items-center gap-1">
                                    <p
                                      className={classNames(
                                        "line-through",
                                        cart?.item?.discount_percent === "0.0"
                                          ? "hidden"
                                          : ""
                                      )}
                                    >
                                      {cart?.item?.variant_price}
                                    </p>
                                    <p className="font-semibold">
                                      ₹{cart?.item?.actual_price}
                                    </p>
                                    <span
                                      className={classNames(
                                        "text-green-700",
                                        cart?.item?.discount_percent === "0.0"
                                          ? "hidden"
                                          : ""
                                      )}
                                    >
                                      {cart?.item?.discount_percent}% off
                                    </span>
                                  </span>
                                  <p className="text-sm">
                                    Delivery Charge : Free
                                  </p>
                                </div>
                                <span className="w-1/4 flex flex-col items-center gap-2">
                                  <img
                                    src={cart?.item?.variant_image}
                                    alt=""
                                    className="h-16 rounded"
                                  />
                                  <span className="flex text-xl items-center border-2 border-zinc-200 dark:border-zinc-700 rounded px-3 gap-2">
                                    <span
                                      className="px-px"
                                      onClick={() =>
                                        decreaseCartWithoutLogin(
                                          cart?.item,
                                          cart?.quantity
                                        )
                                      }
                                    >
                                      -
                                    </span>
                                    <span className="border-x border-zinc-200 dark:border-zinc-700 px-2">
                                      {cart?.quantity}
                                    </span>
                                    <span
                                      onClick={() =>
                                        increaseCartWithoutLogin(
                                          cart?.item,
                                          cart?.quantity
                                        )
                                      }
                                    >
                                      +
                                    </span>
                                  </span>
                                </span>
                              </div>
                              <Divider className="!mx-2" />
                              <div className="flex bg-white dark:bg-zinc-900 rounded-lg">
                                <Button
                                  startIcon={<Beenhere />}
                                  variant="text"
                                  className="!capitalize !rounded-l-lg !rounded-r-none !text-black dark:!text-white w-1/2"
                                  onClick={() => navigate("/login")}
                                >
                                  Save for Later
                                </Button>
                                <div className="border"></div>
                                <Button
                                  startIcon={<DeleteOutlineOutlined />}
                                  onClick={() =>
                                    removeCartWithoutLogin(
                                      cart?.item?.variant_id
                                    )
                                  }
                                  variant="text"
                                  className="!capitalize !rounded-r-lg !rounded-l-none !text-black dark:!text-white w-1/2"
                                >
                                  Remove
                                </Button>
                              </div>
                              <Divider className="!mx-2" />
                            </>
                          );
                        })}
                        <div className="py-2 px-3 bg-white dark:bg-zinc-900 rounded-lg">
                          Price details
                        </div>
                        <Divider className="!mx-2" />
                        <div className="text-right flex bg-white dark:bg-zinc-900 rounded-lg flex-col p-2 gap-2">
                          <p>
                            Total Amount:
                            <span className="font-semibold mx-2">
                              ₹{cart_total_price}
                            </span>
                          </p>
                          <p>
                            Discount:
                            <span className="font-semibold mx-2">
                              ₹{cart_total_price - cart_total_amount}
                            </span>
                          </p>
                          <p>Delivery Charge : Free</p>
                          <Divider />
                          <p className="pb-2">
                            Total Cart Amount:
                            <span className="font-semibold mx-2">
                              ₹{cart_total_amount}
                            </span>
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="fixed flex flex-col bottom-0 border-t-2 border-zinc-200 dark:border-zinc-700 shadow-sm items-center p-3 bg-white dark:bg-zinc-900 w-full">
                    <span className="flex justify-between items-center w-full">
                      <p className="text-xl font-semibold">
                        ₹
                        {cartList?.data?.data?.[0]?.cart_total_amount ||
                          cart_total_amount}
                      </p>
                      <Button
                        className="!rounded-none !px-10"
                        disableElevation
                        variant="contained"
                        onClick={() =>
                          localStorage.getItem("bhaarattoken")
                            ? setStep(1)
                            : navigate("/login")
                        }
                      >
                        Continue
                      </Button>
                    </span>
                  </div>
                </>
              ) : (
                <>
                  <div className="flex flex-col justify-center items-center h-screen gap-5 p-6 text-gray-800 w-full">
                    <img
                      src="https://pub-8de1a28f49c04a568b19557f02b6129b.r2.dev/Assets/PhoneVersion/cartGif.gif"
                      alt=""
                      className="w-2/3"
                    />
                    <span className="flex flex-col gap-1 justify-center items-center">
                      <p className="text-2xl font-bold">Your cart is empty!</p>
                      <p>Add some product to enjoy our services.</p>
                    </span>
                    <Button
                      disableElevation
                      startIcon={<ShoppingCart />}
                      onClick={() => setOpen(false)}
                      variant="contained"
                      className="!capitalize"
                    >
                      Start Shopping
                    </Button>
                  </div>
                </>
              )}
            </>
          )}
          {/* Select Address  */}
          {step === 1 && (
            <>
              <div className="flex flex-col gap-1 px-3 py-2">
                {addressList?.data?.data?.my_address_list?.map(
                  (address, index) => {
                    return (
                      <div
                        key={index + 1}
                        className={classNames(
                          "flex flex-col cursor-pointer hover:shadow hover:shadow-black transition-all duration-200 shadow shadow-black p-4 !rounded",
                          addressId === address.id ? "shadow" : ""
                        )}
                        onClick={() => setAddressId(address.id)}
                      >
                        <span className="flex justify-between">
                          <p className="font-bold">{address.address_type}</p>
                          {addressId === address.id && (
                            <CheckCircle color="success" />
                          )}
                        </span>
                        <p>
                          {address.first_name} {address.last_name}
                        </p>
                        <span className="flex justify-between items-end">
                          <p>
                            {address.address}, {address.area},{" "}
                            {address.street_address}, {address.city},{" "}
                            {address.state}, {address.country},{" "}
                            {address.pincode}
                          </p>
                          {/* {addressId === address.id ? (
                      <Edit
                        fontSize="small"
                        color="warning"
                        // onClick={() => handleUpdate(Number(address?.id))}
                      />
                    ) : null} */}
                        </span>
                      </div>
                    );
                  }
                )}
                <span
                  onClick={() => setIsOpen(true)}
                  className="flex items-center !text-primary cursor-pointer hover:shadow-md shadow p-9 rounded"
                >
                  <Add />
                  <p> Add Address</p>
                </span>
              </div>
              <div className="fixed flex flex-col bottom-0 border-t-2 border-zinc-200 dark:border-zinc-700 shadow-sm items-center p-3 bg-white dark:bg-zinc-900 w-full">
                <span className="flex justify-between w-full">
                  <Button
                    className="!rounded-none"
                    disableElevation
                    variant="outlined"
                    onClick={() => setStep(0)}
                  >
                    Back to Cart
                  </Button>
                  <Button
                    className="!rounded-none"
                    disableElevation
                    disabled={addressId ? false : true}
                    variant="contained"
                    onClick={() => setStep(2)}
                  >
                    Proceed to Payement
                  </Button>
                </span>
              </div>
            </>
          )}
          {/* Select Payment Methods  */}
          {step === 2 && (
            <>
              <div className="flex justify-center items-center w-full flex-col gap-5 p-3">
                <FormControl fullWidth>
                  <RadioGroup
                    value={method}
                    onChange={(event) => setMethod(event.target.value)}
                    className="gap-1 !w-full"
                  >
                    <FormControlLabel
                      value="Online"
                      control={<Radio />}
                      label="Online"
                      className="p-3 rounded border-2 !border-zinc-300 dark:!border-zinc-700  !w-full shadow !m-0"
                    />
                    <FormControlLabel
                      value="COD"
                      control={<Radio />}
                      label="Cash On Delivery"
                      className="p-3 rounded border-2 !border-zinc-300 dark:!border-zinc-700  !w-full shadow !m-0"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="fixed flex flex-col bottom-0 border-t-2 border-zinc-200 dark:border-zinc-700 shadow-sm items-center p-3 bg-white dark:bg-zinc-900 w-full">
                <span className="flex justify-between w-full">
                  <Button
                    className="!rounded-none !px-5"
                    disableElevation
                    variant="outlined"
                    onClick={() => setStep(1)}
                  >
                    back to address
                  </Button>
                  <Button
                    className="!rounded-none w-44"
                    disableElevation
                    disabled={method ? false : true}
                    variant={
                      isLoading || isLoadingOnline || isLoadingOrder
                        ? "outlined"
                        : "contained"
                    }
                    onClick={() => {
                      method === "Online" &&
                        paymentReceipt({
                          address_id: addressId,
                          total_amount:
                            cartList?.data?.data?.[0]?.cart_total_amount,
                        });
                      method === "COD" &&
                        codCheckout({
                          address_id: addressId,
                          coupon_id: "None",
                        });
                    }}
                  >
                    {isLoading || isLoadingOnline || isLoadingOrder ? (
                      <CircularProgress size={25} />
                    ) : (
                      "Place Order"
                    )}
                  </Button>
                </span>
              </div>
            </>
          )}
          {/* Order Placed  */}
          {step === 3 && (
            <>
              <div className="flex flex-col h-[80vh] w-full gap-5 items-center justify-center">
                <CheckCircle className="!text-6xl" color="success" />
                <p className="text-center text-3xl font-semibold">
                  Order Placed
                </p>

                <Button
                  variant="contained"
                  className="!capitalize"
                  onClick={() => navigate("/orders")}
                >
                  Go to My Orders
                </Button>
              </div>
            </>
          )}
        </div>
      </Drawer>
      <Modal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="absolute rounded bg-white dark:bg-zinc-900 left-1/2 shadow w-11/12 h-5/6 top-1/2 -translate-x-1/2 -translate-y-1/2 p-5">
          <form onSubmit={handleSubmit} className="h-full">
            <p className="text-xl font-semibold my-3">
              {!addressId ? "Add Delivery Address" : "Update Delivery Address"}
            </p>
            <div className="grid lg:grid-cols-2 gap-5 h-5/6 overflow-y-auto lg:pr-0 pr-1">
              <span className="w-full">
                <p>Address Type*</p>
                <FormControl fullWidth>
                  <Select
                    id="address_type"
                    name="address_type"
                    color="warning"
                    value={values["address_type"]}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    FormHelperTextProps={{ className: "!text-red-500" }}
                    error={
                      errors["address_type"] && touched["address_type"]
                        ? true
                        : false
                    }
                    helperText={
                      touched["address_type"] && errors["address_type"]
                    }
                  >
                    <MenuItem value={"Home"}>Home</MenuItem>
                    <MenuItem value={"Office"}>Office</MenuItem>
                    <MenuItem value={"Other"}>Other</MenuItem>
                  </Select>
                </FormControl>
              </span>
              <span className="w-full">
                <p>Contact Number*</p>
                <TextField
                  type="number"
                  onBlur={handleBlur}
                  color="warning"
                  className="!w-full !rounded"
                  id="mobile_number"
                  name="mobile_number"
                  value={values["mobile_number"]}
                  onChange={handleChange}
                  error={
                    errors["mobile_number"] && touched["mobile_number"]
                      ? true
                      : false
                  }
                  helperText={
                    touched["mobile_number"] && errors["mobile_number"]
                  }
                  FormHelperTextProps={{ className: "!text-red-500" }}
                />
              </span>
              <span className="w-full">
                <p>Flat/House No./Compnay Name*</p>
                <TextField
                  type="text"
                  onBlur={handleBlur}
                  color="warning"
                  id="address"
                  name="address"
                  value={values["address"]}
                  onChange={handleChange}
                  className="!w-full !rounded"
                  error={errors["address"] && touched["address"] ? true : false}
                  helperText={touched["address"] && errors["address"]}
                  FormHelperTextProps={{ className: "!text-red-500" }}
                />
              </span>
              <span className="w-full">
                <p>Area/Landmark*</p>
                <TextField
                  type="text"
                  onBlur={handleBlur}
                  color="warning"
                  id="area"
                  name="area"
                  value={values["area"]}
                  onChange={handleChange}
                  className="!w-full !rounded"
                  error={errors["area"] && touched["area"] ? true : false}
                  helperText={touched["area"] && errors["area"]}
                  FormHelperTextProps={{ className: "!text-red-500" }}
                />
              </span>

              <span className="w-full">
                <p>Street/Sector/Village*</p>
                <TextField
                  type="text"
                  onBlur={handleBlur}
                  color="warning"
                  id="street_address"
                  name="street_address"
                  value={values["street_address"]}
                  onChange={handleChange}
                  className="!w-full !rounded"
                  error={
                    errors["street_address"] && touched["street_address"]
                      ? true
                      : false
                  }
                  helperText={
                    touched["street_address"] && errors["street_address"]
                  }
                  FormHelperTextProps={{ className: "!text-red-500" }}
                />
              </span>
              <span className="w-full">
                <p>Pincode*</p>
                <TextField
                  type="number"
                  onBlur={handleBlur}
                  color="warning"
                  id="pincode"
                  name="pincode"
                  value={values["pincode"]}
                  onChange={handleChange}
                  className="!w-full !rounded"
                  error={errors["pincode"] && touched["pincode"] ? true : false}
                  helperText={touched["pincode"] && errors["pincode"]}
                  FormHelperTextProps={{ className: "!text-red-500" }}
                />
              </span>
              <span className="w-full">
                <p>Email*</p>
                <TextField
                  type="text"
                  onBlur={handleBlur}
                  color="warning"
                  className="!w-full !rounded"
                  id="email"
                  name="email"
                  value={values["email"]}
                  onChange={handleChange}
                  error={errors["email"] && touched["email"] ? true : false}
                  helperText={touched["email"] && errors["email"]}
                  FormHelperTextProps={{ className: "!text-red-500" }}
                />
              </span>

              <span className="w-full">
                <p>Country*</p>
                <FormControl fullWidth>
                  <Select
                    id="country_id"
                    onBlur={handleBlur}
                    color="warning"
                    name="country_id"
                    value={values["country_id"]}
                    onChange={handleChange}
                    error={
                      errors["country_id"] && touched["country_id"]
                        ? true
                        : false
                    }
                    helperText={touched["country_id"] && errors["country_id"]}
                    FormHelperTextProps={{ className: "!text-red-500" }}
                  >
                    {country?.data?.data?.map((country) => {
                      return (
                        <MenuItem value={country.id}>
                          {country.country}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </span>
              <span className="w-full">
                <p>State*</p>
                <FormControl fullWidth>
                  <Select
                    id="state_id"
                    onBlur={handleBlur}
                    name="state_id"
                    color="warning"
                    value={values["state_id"]}
                    onChange={handleChange}
                    error={
                      errors["state_id"] && touched["state_id"] ? true : false
                    }
                    helperText={touched["state_id"] && errors["state_id"]}
                    FormHelperTextProps={{ className: "!text-red-500" }}
                  >
                    {state?.data?.data?.map((state) => {
                      return (
                        <MenuItem value={state.id}>{state.state}</MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </span>
              <span className="w-full">
                <p>City*</p>
                <FormControl fullWidth>
                  <Select
                    id="city_id"
                    onBlur={handleBlur}
                    name="city_id"
                    color="warning"
                    value={values["city_id"]}
                    onChange={handleChange}
                    error={
                      errors["city_id"] && touched["city_id"] ? true : false
                    }
                    helperText={touched["city_id"] && errors["city_id"]}
                    FormHelperTextProps={{ className: "!text-red-500" }}
                  >
                    {city?.data?.data?.map((city) => {
                      return <MenuItem value={city.id}>{city.city}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </span>
            </div>
            <span className="flex justify-center py-4">
              <Button disableElevation variant="contained" type="submit">
                Submit
              </Button>
            </span>
          </form>
        </Box>
      </Modal>
    </>
  );
};

export default Checkout;
